<template>
  <div>
    <div class="container mb-0 mb-sm-3 mb-lg-5">
      <div class="row ib-default-flex in-our-app-row">
        <div class="col-md-6 col-xl-5">
          <h2 class="ib-section-title mb-0 wow animate__animated animate__fadeInRight pt-1 pt-sm-2">
              <span>Get</span> Our App
            </h2>
            <h4 class="ib-get-subtitle wow animate__animated animate__fadeInLeft">Get control of all your insurance needs anywhere, anytime.</h4>

            <div class="promotion-container">
                <div class="promotion-box">
                  <div>
                    <img class="img-fluid" :src="require('@/assets/images/Discounts.svg')" alt="icon">
                  </div>
                  <div>Discounts</div>
                </div>
                <div class="promotion-box">
                  <div>
                    <img class="img-fluid" :src="require('@/assets/images/Offers.svg')" alt="icon">
                  </div>
                  <div>Offers</div>
                </div>
                <div class="promotion-box">
                  <div>
                    <img class="img-fluid" :src="require('@/assets/images/Promotions.svg')" alt="icon">
                  </div>
                  <div>Promotions</div>
                </div>
            </div>


            <ul class="ib-get-app">
              <li>24/7 Accessibility</li>
              <li>Comparisons of Insurance Plans</li>
              <li>Convenience of Transacting</li>
              <li>Post Buy Policy Servicing</li>
              <li>Activity Notifications</li>
              <li>Claim Intimation Digitally</li>
              <li>Renewal Management</li>
              <li>Paperless Journey</li>
            </ul>

            <div class="d-md-none">
              <img class="img-fluid wow animate__animated animate__fadeInUp" :src="require('@/assets/images/bg/info-for-get-app.svg')" alt="get download app icon">
            </div>

            <!-- download app links -->
            <ul class="list-inline text-center text-md-left" style="padding: 13px 0px 0px 11px;">
              <!-- mb-3 -->
              <li class="list-inline-item">
                <a href="https://apps.apple.com/us/app/insurance-bazaar/id1582637611" target="_blank">
                  <img alt="Apple Icon" class="ib-download-app img-fluid" :src="require('@/assets/images/download-apple.svg')"/>
<!--                  <img alt="Apple Icon" class="ib-download-app img-fluid in-sm-12" :src="require('@/assets/images/download-apple-new.png')"/>-->
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://play.google.com/store/apps/details?id=com.ozoneddigital.insuranceBazaar" target="_blank">
                  <img
                    alt="PlayStore Icon"
                    class="ib-download-app img-fluid"
                    :src="require('@/assets/images/download-googleplay.svg')"
                  />
                </a>
              </li>
            </ul>
        </div>
        <div class="col-md-6 col-xl-7 in-getapp-bg">
          <div class="d-none">
            <img class="img-fluid wow animate__animated animate__fadeInUp" :src="require('@/assets/images/bg/info-for-get-app.svg')" alt="get download app icon">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'GetApp',
    data () {
      return {
      }
    },
    components: {
    },
    created () {
    },
    methods: {
    }
  }
</script>

<style scoped>
  .in-sm-12 {
    position: relative;
    bottom: 15px;
  }
  @media(max-width:550px) {
    .ib-get-app li {
      margin: 0px 0px 10px !important;
    }
    .ib-get-app li::before {
      content: '';
      top: 0px !important;
    }
    .in-sm-12 {
      position: relative;
      bottom: 13px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/GetApp.vue